import gql from "graphql-tag";

export const updateDealerCompany = gql`
  mutation updateCompany($oneCId: String!, $companyId: ID!, $isActive: Boolean) {
    updateCompany(oneCId: $oneCId, id: $companyId, isActive: $isActive) {
      id
    }
  }
`;
